import { render, staticRenderFns } from "./ActiveQueueSummary.vue?vue&type=template&id=4b6ec777&"
import script from "./ActiveQueueSummary.vue?vue&type=script&lang=js&"
export * from "./ActiveQueueSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports